import type { FaireProductEntity } from "../../entity_types/product";

export const p_cufdf4884q: FaireProductEntity = {
  token: "p_cufdf4884q",
  type: "product",
  name: "Women's Cozy Fuzzy Crew Socks Assorted Designs",
  brandName: "Crover",
  imageUrl:
    "https://cdn.faire.com/fastly/4314ed900a78c1290e8d7afd8c2d1b1bb414aa6f20a35f1fec20f4137de1a56f.jpeg",
  priceDollars: 0,
  description: "",
  categoryTokens: ["cat_accessories"],
  tags: [],
  meta: {
    source: "mock",
    importedAt: "2026-03-24T13:23:30Z",
    importedBy: "retailerThemesSeed-migration",
  },
  freeShipping: false,
  brandAvatarUrl:
    "https://cdn.faire.com/fastly/95f56c794874baab13dc7a0b67bc8060fc2f358c475df45fc8f1e770e788a6a4.jpeg",
  weight: 1,
  dimensions: {
    width: 6,
    height: 6,
    depth: 4,
  },
  inStock: true,
};
